"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var email_info_1 = require("../../components/member/email-info");
var phone_number_info_1 = require("../../components/member/phone-number-info");
var ContactInfo = function (_a) {
    var _b, _c;
    var contact = _a.contact;
    return (React.createElement("address", null,
        React.createElement("p", { className: "u-textSemiBold u-spaceBottomSm" },
            contact.firstName,
            " ",
            contact.lastName,
            (contact === null || contact === void 0 ? void 0 : contact.label) &&
                React.createElement("span", { className: "u-spaceLeftXs" },
                    "(",
                    contact.label,
                    ")")), (_b = contact === null || contact === void 0 ? void 0 : contact.emailAddresses) === null || _b === void 0 ? void 0 :
        _b.map(function (emailAddress) { return React.createElement(email_info_1.default, { key: "email-" + emailAddress.id, emailAddress: emailAddress }); }), (_c = contact === null || contact === void 0 ? void 0 : contact.phoneNumbers) === null || _c === void 0 ? void 0 :
        _c.map(function (phoneNumber) { return React.createElement(phone_number_info_1.default, { key: "phone-number-" + phoneNumber.id, phoneNumber: phoneNumber }); })));
};
exports.default = ContactInfo;
//# sourceMappingURL=contact-info.js.map